import type { Router } from "vue-router";

import { NProgress } from "@/plugins/nprogress";

export function setupProgressGuard(router: Router) {
  router.beforeEach(() => {
    NProgress.start();
  });

  router.afterEach(() => {
    NProgress.done();
  });

  router.onError(() => {
    NProgress.done();
  });
}
